module.exports = __webpack_public_path__ + "7f7070e08fa1722372098f83aba74ce7.woff";